import type {
  Block,
  ParagraphData,
} from "../../../../models/ManualAuthoring";

import { useManualAuthoringStore } from "../../../../store/manualAuthoringStore";
import SimpleInlineTextEditor from "../editor/SimpleInlineTextEditor";
import "./subheading.css";

export default function SubheadingEdit({
  block,
  onDone,
}: {
  block: Block;
  onDone: () => void;
}) {
  const updateBlock = useManualAuthoringStore((s) => s.updateBlock);
  const data = block.data as ParagraphData;

  return (
    <div className="pdf-block pdf-subheading-edit">
      <SimpleInlineTextEditor
        textParts={data.textParts || []}
        onChange={(newParts) => updateBlock(block.id, { textParts: newParts })}
        onDone={onDone}
      />
    </div>
  );
}
